import { createSlice } from '@reduxjs/toolkit'
import { getUserData } from '../utils/localStorage';

const initialState = {
    accessToken: getUserData().token,
    userRole: getUserData().userProfileRole,
    isSidebarOpen: true
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.accessToken = action.payload
        },
        clearToken: (state) => {
            state.accessToken = null;
            state.userRole = null; // Clear userRole when token is removed
        },
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen
        },
    },
});

export const { setToken, clearToken, toggleSidebar } = authSlice.actions;

export default authSlice.reducer

